'use strict';
(self.webpackChunkyourkaya = self.webpackChunkyourkaya || []).push([
  [4811],
  {
    8079: (t, e, s) => {
      var o = s(9897);
      class r extends o.oi {
        constructor() {
          super();
          this.disableSorting = this.disableSorting.bind(this);
          this.active = !1;
          this.selectors = {
            label: '.sort',
            sort: '.dropdown',
            sortItem: '.facet-filters__value',
            sortAttr: 'data-sort',
            sortActive: 'active',
          };
        }
        connectedCallback() {
          super.connectedCallback(),
            window.addEventListener('click', this.disableSorting),
            this.querySelector(this.selectors.label).addEventListener('click', (t) => this.toggleSorting(t)),
            this.setSorting();
        }
        disconnectedCallback() {
          super.disconnectedCallback(), window.removeEventListener('click', this.disableSorting);
        }
        disableSorting() {
          this.querySelector('.icon').classList.remove(this.selectors.sortActive);
          this.querySelector(this.selectors.sort).classList.remove(this.selectors.sortActive);
        }
        toggleSorting(t) {
          t.stopPropagation(), this.querySelector('.icon').classList.toggle(this.selectors.sortActive);
          this.querySelector(this.selectors.sort).classList.toggle(this.selectors.sortActive);
        }
        setSorting() {
          this.querySelectorAll(this.selectors.sortItem).forEach((t) => {
            const e = t.getAttribute(this.selectors.sortAttr);
            t.addEventListener('click', async () => {
              await dataLayerPromise({
                event: 'filters_interaction',
                section: 'sorting_filter',
                element: 'drop-down',
                element_value: e,
                interaction_type: 'change',
              });
              const t = new URL(window.location);
              t.searchParams.set('sort_by', e);
              t.searchParams.delete('page');
              window.location = t;
            });
          });
        }
        render() {
          return o.dy`<slot></slot>`;
        }
      }
      window.customElements.define('ba-sort', r);
    },
  },
  (t) => {
    t.O(0, [1216], () => {
      return (e = 8079), t((t.s = e));
      var e;
    });
    t.O();
  },
]);
